// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bN_hS","column":"bN_gk","columnItems":"bN_hT","title":"bN_f","linkContainer":"bN_hV","link":"bN_cn"};